import React, { useContext, useEffect } from 'react';

import { isEmpty } from 'ramda';

import Text from 'components/shared/Typography/Text';
import { ITINERARIES_ITEM_TYPES, LANDING_PAGE_ROLES } from 'constants/index';
import { getDateFormat } from 'utils/date';

import { IWay } from '../../../../components/Pages/Admin/shared/ItinerariesItemLanding/Builder/types';
import { getLandingV2Config } from '../../../LandingV2/functions';
import { List } from '../../../LandingV2/Page/RightSide/blocks/OverviewMap';
import MapPoints from '../../../LandingV2/Page/RightSide/blocks/OverviewMap/MapPoints';
import { PDFDataContext } from '../../context';
import { IWithOnReady } from '../../types';
import SafariOverviewHeader from '../shared/SafariOverviewHeader';
import TemplatePage from '../TemplatePage';
import s from './index.module.css';

const MAP_WIDTH = 430;

function MapPage({ onReady }: IWithOnReady) {
  const { page } = useContext(PDFDataContext);
  const mapContainerStyle = { width: MAP_WIDTH + 'px', height: '320px' };
  const collection = page?.way as IWay[];
  const scheduleType = page?.scheduleType;
  const pageJSON = page.landing.pages.find((p) => p.role === LANDING_PAGE_ROLES.SAFARI_MAP);
  const title = pageJSON?.title;
  const points = collection?.map((item) => ({ lat: Number(item?.latitude), lng: Number(item?.longitude) }));
  const showCondition = !pageJSON || pageJSON.hidden || isEmpty(collection);

  useEffect(() => {
    console.log('---- MapPage', showCondition);
    if (showCondition) {
      onReady();
    }
  }, [collection]);

  if (showCondition) {
    return null;
  }

  return (
    <TemplatePage>
      <SafariOverviewHeader title={title} />
      <div className={s.body}>
        <div style={{ width: MAP_WIDTH + 'px', margin: '0 auto' }}>
          <MapPoints
            containerStyle={mapContainerStyle}
            points={points}
            mapConfig={getLandingV2Config(page.landingConfig).map}
            onReady={onReady}
          />
        </div>
        <div className={s.summary}>
          <div>
            <Text isStrong className={s.summaryTitle}>
              Summary
            </Text>
          </div>
          <Text className={s.details}>
            <List
              collection={collection}
              scheduleType={scheduleType}
              isLookbook={page.type === ITINERARIES_ITEM_TYPES.LOOKBOOK}
              pointsView="normal"
              dateFormat={getDateFormat(page?.settings?.displayDatesDdMmYyyy)}
            />
          </Text>
        </div>
      </div>
    </TemplatePage>
  );
}

export default MapPage;
